"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importStar(require("react"));
const context_1 = require("./context");
const hooks_1 = require("./hooks");
const react_hanger_1 = require("react-hanger");
const Inner_1 = require("./Inner");
exports.ContentImportPanel = ({ onChange, usePortal = true, contentFeed, onClose, onChangeContentFeed, }) => {
    var _a, _b, _c;
    const { state, setState } = react_hanger_1.useSetState({
        searchQuery: '',
        showSearch: false,
    });
    const contentItemsResult = hooks_1.useContentItems(contentFeed);
    react_2.useEffect(() => {
        var _a, _b, _c;
        if ((_c = (_b = (_a = contentItemsResult) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.contentItems) === null || _c === void 0 ? void 0 : _c.length) {
            setState({
                showSearch: true,
            });
        }
    }, [(_c = (_b = (_a = contentItemsResult) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.contentItems) === null || _c === void 0 ? void 0 : _c.length]);
    const isLoadingContentItems = react_1.queryIsLoading(contentItemsResult);
    return (react_2.default.createElement(context_1.ContentImportPanelDataContext.Provider, { value: Object.assign({ contentFeed,
            contentItemsResult,
            isLoadingContentItems }, state) },
        react_2.default.createElement(context_1.ContentImportPanelUpdateContext.Provider, { value: { onChange, onChangeContentFeed, onClose, setState } },
            react_2.default.createElement(Inner_1.ContentImportPanelInner, { usePortal: usePortal, onClose: onClose }))));
};
//# sourceMappingURL=index.js.map